/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext } from 'react'
import Skeleton from 'react-loading-skeleton'

import handleNotification from 'utils/toast/handleNotification'

// Context
import { MovementsContext } from 'contexts/movements'
import { MeContext } from 'contexts/me'
import { tableItemButton } from 'constants/tableItem'

// Utils
import { moneyFormat } from 'utils'

// Table
import Table from './table'
import TableItem from './TableItem'

interface AccountInformationProps {
  showCvu?: boolean
  label?: string | JSX.Element
  className?: string
  limit?: number
  isCashout?: boolean
}

const AccountInformation = ({
  label = 'SALDO DISPONIBLE',
  className = '',
  limit = null,
  isCashout = false
}: AccountInformationProps) => {
  const { me } = useContext(MeContext)
  const { amountBalance } = useContext(MovementsContext)
  const { successToast } = handleNotification()

  function onCopy() {
    navigator.clipboard.writeText(me?.bank?.internal_account[0].cvu)
    successToast('Los datos se han copiado en portapapeles')
  }

  if (amountBalance && me) {
    return (
      <Table className={`!px-3 sm:!px-6 ${className}`}>
        <div className='flex flex-col items-center font-medium py-4 text-xs leading-[140%] border-b last:border-0 border-solid border-gray-500'>
          <div className='text-black text-center font-bold text-xs mb-2 w-full'>
            {label}
          </div>
          <p
            className={`font-bold text-black mt-2 pb-5 pt-2 ${
              parseInt(amountBalance, 10) >= 100000 ? 'text-4xl' : 'text-5xl'
            }`}
          >
            {limit === 0 && '$ 0,00'}
            {limit > 0 && moneyFormat(limit)}
            {limit == null && moneyFormat(amountBalance)}
          </p>
          {typeof limit === 'number' ? (
            <p className='text-xs font-bold text-gray-900'>
              de {moneyFormat(amountBalance)} del saldo total
            </p>
          ) : null}
        </div>
        {!isCashout && (
          <TableItem
            label='CVU'
            value={me?.bank?.internal_account[0].cvu}
            buttonType={tableItemButton.COPY}
            onClick={onCopy}
          />
        )}
      </Table>
    )
  }

  return <Skeleton height={!isCashout ? 187 : 135} />
}

export default AccountInformation
